'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishSC = exports.publishRAT = exports.appendTagsData = exports.publishDMP = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ThirdPartyTags
/* global tags */
var publishDMP = exports.publishDMP = function publishDMP() {
  var data = window.tags.data;
  if (data.page.id && data.page.name) {
    console.log('publish DMP tag');
    window.grp15_prm = {
      service: data.contents.repository === 'm17n' ? 'TRVM17N' : '',
      page: data.page.name,
      rakuten_pid: data.page.id,
      hotelid: data.browse ? data.browse.items.map(function (item) {
        return item.provider.id;
      }).slice(0, 3) : [],
      d: data.user.device,
      domain: data.domain
    };
    var script = document.createElement('script');
    script.id = 'tags-m17n';
    script.charset = 'UTF-8';
    script.type = 'text/javascript';
    script.src = '//ias.r10s.jp/grp15/trvm17n.js';
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');
    document.body.appendChild(script);
  }
};

var appendTagsData = exports.appendTagsData = function appendTagsData(data) {
  if (!window.tags) window.tags = {};
  if (!window.tags.data) window.tags.data = {};
  window.tags.data = (0, _extends3.default)({}, data);
};

var publishRAT = exports.publishRAT = function publishRAT() {
  console.log('publish RAT tag');
  var tags = window.tags;
  tags.track.appendTag();
  tags.track.load(tags.track.url, function () {
    tags.track.handleRATTagEvent();
  });
};

var publishSC = exports.publishSC = function publishSC() {
  var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _moment2.default)();

  console.log('publish SC tag');
  var data = window.tags.data;
  var s = window.s;
  var checkin = _lodash2.default.get(data, 'query.items[0].from.date');
  var checkout = _lodash2.default.get(data, 'query.items[0].to.date');
  var country = _lodash2.default.get(data, 'query.items[0].from.country');
  var prefecture = _lodash2.default.get(data, 'query.items[0].from.prefecture');
  var city = _lodash2.default.get(data, 'query.items[0].from.city');
  var spot = _lodash2.default.get(data, 'query.items[0].from.spot');
  var adults = Number(_lodash2.default.get(data, 'query.items[0].guest.adult') || 0);
  var children = Number(_lodash2.default.get(data, 'query.items[0].guest.child') || 0);
  var min = _lodash2.default.get(data, 'query.items[0].price.min');
  var max = _lodash2.default.get(data, 'query.items[0].price.max');
  var type = _lodash2.default.get(data, 'page.type');
  var orderBy = _lodash2.default.get(data, 'query.orderBy');

  s.channel = type === 'home' ? 'Top' : type === 'search' ? 'search' : type === 'product' ? 'hotel' : '';
  s.pageName = _lodash2.default.get(data, 'page.sc');
  s.eVar10 = _lodash2.default.get(data, 'query.items[0].from.spot');
  s.eVar12 = type === 'product' ? (_lodash2.default.get(data, 'query.items[0].provider.id') || [''])[0] : '';
  s.eVar13 = type === 'product' ? (_lodash2.default.get(data, 'query.items[0].provider.id') || [''])[0] : '';
  s.eVar14 = checkin && checkout ? checkin + ':' + checkout : '';
  s.eVar15 = '' + country + (prefecture ? ':' + prefecture : '') + (city ? ':' + city : '') + (spot ? ':' + spot : '');
  s.eVar16 = '' + country + (prefecture ? ':' + prefecture : '') + (city ? ':' + city : '') + (spot ? ':' + spot : '');
  s.eVar17 = checkin ? (0, _moment2.default)(checkin, 'YYYY-MM-DD').diff(now.startOf('day'), 'days') : '';
  s.eVar18 = checkin && checkout ? (0, _moment2.default)(checkout, 'YYYY-MM-DD').diff((0, _moment2.default)(checkin, 'YYYY-MM-DD'), 'days') : '';
  s.eVar19 = adults ? adults + ':' + children + ':' + (adults + children) : '';
  s.eVar21 = min && max ? min + '-' + max : '';
  s.eVar29 = _reactCookie2.default.load('gridt') ? '1' : '0';

  s.prop5 = '' + country + (prefecture ? ':' + prefecture : '') + (city ? ':' + city : '') + (spot ? ':' + spot : '');
  s.prop6 = type === 'product' ? (_lodash2.default.get(data, 'query.items[0].provider.id') || [''])[0] : '';
  s.prop7 = _lodash2.default.get(data, 'browse.items').length ? 1 : 0;
  s.prop9 = orderBy === 'price desc' ? '5' : orderBy === 'price' ? '4' : orderBy === 'rate desc' ? '3' : orderBy === 'review desc' ? '2' : orderBy === 'recommend desc' ? '1' : '1';
  try {
    var scode = window.s.t();
    if (scode) {
      document.write(scode);
    }
  } catch (e) {
    window.rakutenSC.log(e);
  }
};

var ThirdPartyTags = function (_Component) {
  (0, _inherits3.default)(ThirdPartyTags, _Component);

  function ThirdPartyTags() {
    (0, _classCallCheck3.default)(this, ThirdPartyTags);
    return (0, _possibleConstructorReturn3.default)(this, (ThirdPartyTags.__proto__ || (0, _getPrototypeOf2.default)(ThirdPartyTags)).apply(this, arguments));
  }

  (0, _createClass3.default)(ThirdPartyTags, [{
    key: 'componentDidMount',


    // First time to load page
    value: function componentDidMount() {
      if (this.props.loaded) {
        appendTagsData(this.props.data);
        window.addEventListener('load', function () {
          // When page loaded, first time of publish RAT will be called by tags.track.js
          publishDMP();
          publishSC();
        });
      }
    }

    // When user change location,
    // XXX: Required to publish when switch loaded status to true from false

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.loaded && nextProps.loaded) {
        appendTagsData(this.props.data);
        publishRAT();
        publishDMP();
        publishSC();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);
  return ThirdPartyTags;
}(_react.Component);

ThirdPartyTags.propTypes = {
  loaded: _react.PropTypes.bool.isRequired,
  data: _react.PropTypes.object.isRequired
};

exports.default = ThirdPartyTags;


//////////////////
// WEBPACK FOOTER
// ./src/components/ThirdPartyTags.js
// module id = 1228
// module chunks = 0